import { Pipe, PipeTransform } from '@angular/core';
import { Delimiter } from '../constants/delimiter';

@Pipe({
  name: 'joinByDelimiter',
})
export class JoinByDelimiterPipe implements PipeTransform {
  private delimiter = Delimiter.Comma + Delimiter.Space;
  transform(value: string[], delimiter?: string): string {
    if (delimiter) {
      this.delimiter = delimiter;
    }

    return value?.length ? value.join(this.delimiter) : null;
  }
}
